import React, { useState } from "react";
import logo from "../logo-vpvv.png";
// import "./Iceremony.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
// import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const IcBodyMeasurementDetails = () => {
  const [lgShow, setLgShow] = useState(true);
  // const [numGuests, setNumGuests] = useState(1);
  const location = useLocation();
  const [numGuests, setNumGuests] = useState(location.state?.numGuests || 1);
  const IcBloodDetails = useNavigate();
  const gotoIcBloodDetails = () => {
    IcBloodDetails("/IcBloodDetails", { state: { numGuests } });
  };
  const [step, setSteps] = useState(2);

  return (
    <>
      {/* Main Container */}
      <div className="ic-container">
        <img src={logo} alt="logo" style={{ width: "150px" }} />
        <h2 style={{ color: "white" }}>
          VPVV TECHNO CONSTRUCTION PRIVATE LIMITED
        </h2>

        {/* Dynamically Render Forms */}
        <div className="ic-form">
          <h2 className="form-title">Body Measurment</h2>
          <div className="progress_container">
            <div className={`${step >= 1 ? "circle active" : "circle"}`}>1</div>
            <div className={`${step >= 2 ? "circle active" : "circle"}`}>2</div>
            <div className={`${step >= 3 ? "circle active" : "circle"}`}>3</div>
            <div className={`${step >= 4 ? "circle active" : "circle"}`}>4</div>
            <div className={`${step >= 5 ? "circle active" : "circle"}`}>5</div>
          </div>
          {Array.from({ length: numGuests }).map((_, index) => (
            <div key={index}>
              {/* Body Measurment */}
              <h5 className="guestSeries">Guest {index + 1}</h5>

              <Form>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId={`formGridHeight`}>
                    <Form.Label>Height</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridChest`}>
                    <Form.Label>Chest</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridShoulder`}>
                    <Form.Label>Shoulder</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId={`formGridBicep`}>
                    <Form.Label>Bicep</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridSleeve`}>
                    <Form.Label>Sleeve Length</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridHip`}>
                    <Form.Label>Hip</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} controlId={`formGridThigh`}>
                    <Form.Label>Thigh</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridLeg`}>
                    <Form.Label>Leg Lenght</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                  <Form.Group as={Col} controlId={`formGridWrist`}>
                    <Form.Label>Wrist</Form.Label>
                    <Form.Control type="number" placeholder="in cm" required />
                  </Form.Group>
                </Row>
              </Form>
            </div>
          ))}
          <Button
            variant="primary"
            type="submit"
            style={{ width: "670px", marginTop: "1rem" }}
            onClick={gotoIcBloodDetails}
          >
            Save & Continue
          </Button>
        </div>
      </div>
    </>
  );
};

export default IcBodyMeasurementDetails;
